import { get } from '../Services/http';
import { catchError } from './Error.action';
import { showLoader, hideLoader } from '../Actions/Loader.action';

export const ACCOUNT_SUMMARY_RECEIVE = 'ACCOUNT_SUMMARY_RECEIVE';
export const ACCOUNT_SUMMARY_ERROR = 'ACCOUNT_SUMMARY_ERROR';
export const ACCOUNT_SUMMARY_CURRENT_VIEW = 'ACCOUNT_SUMMARY_CURRENT_VIEW';

export const receive = (data) => ({
    type: ACCOUNT_SUMMARY_RECEIVE,
    payload: {
        data,
    },
});

export const setError = (error) => ({
    type: ACCOUNT_SUMMARY_ERROR,
    payload: {
        error,
    },
});

export const setCurrentView = (view, dateFrom, dateTo) => ({
    type: ACCOUNT_SUMMARY_CURRENT_VIEW,
    payload: {
        currentView: view,
        invoiceDateFrom: dateFrom ?? '',
        invoiceDateTo: dateTo ?? '',
    },
});

export const query = () => (dispatch) => {
    dispatch(showLoader());
    return get('api/erp/accountSummary')
        .then((response) => response.json())
        .then((result) => {
            dispatch(receive(result));
            dispatch(hideLoader());
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};
